export const Transactions = {
  NOTA_FISCAL: 1,
  TRANSFERENCIA_INTERNA: 2,
  TRANSFERENCIA_TITULARIDADE: 3,
  EXPORTACAO: 4,
  ESTORNO: 5,
  EMPRESTIMO: 6
};
